import { canFilter } from '../../mixins/can_filter';

angular
  .module('app.views')
  .config(($routeProvider) => {
    $routeProvider.when('/orders', {
      template: require('./orders.html'),
      controller: 'OrdersController'
    });
  })
  .controller('OrdersController', function ($scope, $location, Order, Inventory, Account) {
    $scope.PAGE_SIZE = 25;
    $scope.selectedAccount = [];

    // Pick off filter params from the URL
    canFilter($scope, $location);
    _.pick($scope, 'q', 's', 'p');

    // Get inventory numbers
    Inventory.get((results) => {
      $scope.inventory = results;
    }, (err) => {
      toaster.pop({
        type: 'error',
        body: `Error loading inventory.`,
        timeout: 2000,
      });
      console.error(err);
    });

    function loadOrders(p) {
      $scope.loading = true;
      $scope.pagination = {};
      $scope.orders = [];
      let params = {
          page: p,
          page_size: $scope.PAGE_SIZE,
          'filter.status': $scope.orderStatus,
          'filter.sku': $scope.sku,
      }
      // Filter bu account, if necessary
      if ($scope.f.account) {
        params['filter.account_id'] = $scope.f.account.id;
        if ($scope.selectedAccount.length == 0) {
          $scope.selectedAccount.push($scope.f.account)
        }
      }
      return Order.query(params, (res, headers) => {
        $scope.orders = res;
        if (headers) {
          let pagination = JSON.parse(headers('x-pagination'));
          if (pagination) {
            $scope.currentPage = pagination.page;
            $scope.totalPages = Math.ceil(pagination.total_count / pagination.page_size);
            $scope.totalOrders = pagination.total_count;
          }
        }
        $scope.loading = false;
      }, (err) => {
        toaster.pop({
          type: 'error',
          body: `Error loading orders.`,
          timeout: 2000
        });
        console.error(err);
      }).$promise;
    }

    $scope.setOrderStatus = function(status) {
      $scope.orderStatus = status;
      loadOrders(1);
    }

    $scope.setItem = function(item) {
      $scope.sku= item;
      loadOrders(1);
    }

    $scope.onSelectAccount = function(account) {
      if (account.name.length > 35) {
        account.name = account.name.substring(0, 35) + ' ...';
      }
      $scope.filter('account', account);
      loadOrders(1);
    }

    $scope.onRemoveAccount = function() {
      $scope.filter('account', undefined)
      loadOrders(1);
    }

    $scope.searchAccounts = text=> Account.query({q: text, l:200}).$promise;

    $scope.next = () => loadOrders($scope.currentPage + 1);
    $scope.previous = () => loadOrders($scope.currentPage - 1);
    $scope.first = () => loadOrders(1);
    $scope.last = () => loadOrders($scope.totalPages);

    // Initialize request options
    $scope.orderStatus = 'awaiting_shipment';
    $scope.query = null;
    $scope.sku = null;

    // Load the first page
    $scope.first();
  });



// WEBPACK FOOTER //
// ./views/orders/orders_controller.js